import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaPerformanceLog = React.lazy(() =>
    import('../NebulaPerformanceLog')
);
const nebulaPerformanceLogRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_PERFORMANCE_LOG_PAGE,
        element: <NebulaPerformanceLog />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaPerformanceLogRoutesRegistry;
